import i18n from 'i18next';
import dayjs from 'dayjs';

export function timeDecorator(value: string) {
    return dayjs(value).format(i18n.t('COMMON.DATE_FORMATS.LONG_FORMAT'));
}
